import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["subcategorySelect"]

  connect() {
    this.updateSubcategories()
  }

  async updateSubcategories(event) {
    const categorySelect = event?.target || document.querySelector('select[name*="category_ids"]')

    if (categorySelect?.selectedOptions.length > 0) {
      const categoryIds = [...categorySelect.selectedOptions].map(opt => opt.value)

      const subcategories = await this.fetchSubcategories(categoryIds)

      const tomSelect = this.subcategorySelectTarget.tomselect
      tomSelect.clearOptions()
      subcategories.forEach(sub => tomSelect.addOption({ value: sub.id, text: sub.title }))
      tomSelect.refreshOptions(false)
    }
  }

  async fetchSubcategories(categoryIds) {
    const queryString = categoryIds.map(id => `ids[]=${id}`).join("&")
    const response = await fetch(`/categories/subcategories?${queryString}`)
    return response.json()
  }
}
